export function getBaseName(filename: string): string {
  const suffixDotIndex = filename.lastIndexOf('.')
  if (suffixDotIndex === -1) {
    return filename
  }
  return filename.substring(0, suffixDotIndex)
}

/**
 * 检测是否重名，忽略后缀名
 * @param name1
 * @param name2
 */
export function isDupFilename(name1: string, name2: string) {
  const baseName1 = getBaseName(name1)
  const baseName2 = getBaseName(name2)
  return baseName1 === baseName2
}
export function getBaseName(filename: string): string {
  const suffixDotIndex = filename.lastIndexOf('.')
  if (suffixDotIndex === -1) {
    return filename
  }
  return filename.substring(0, suffixDotIndex)
}

/**
 * 检测是否重名，忽略后缀名
 * @param name1
 * @param name2
 */
export function isDupFilename(name1: string, name2: string) {
  const baseName1 = getBaseName(name1)
  const baseName2 = getBaseName(name2)
  return baseName1 === baseName2
}
